module.exports = __webpack_public_path__ + "static/80218560_591154028115417_5488276469740208128_n_optimized-f48667626db37b10610def4d63ccfdd8.jpg";